import React from 'react'

import { REPORT_VIEWER_MODE } from '../constants'

import { useStyles } from './report-page-layout.style'

export const ReportPageLayout = function ({ mode, hasPageControlBar, contentClassName = '', children }) {
  const classes = useStyles()

  if (mode === REPORT_VIEWER_MODE.READ) {
    return hasPageControlBar
      ? (
        <div className={`page-header-layout`}>
          <div className="page-header"></div>
          <div className="page-content">
            <div className={`${classes.pageLayoutContent} ${classes.marginBelowControlBar} ${contentClassName}`}>
              {children}
            </div>
          </div>
        </div>
      )
      : (
        <div className={`${classes.pageLayoutContent} ${classes.readOnlyMarginTop} ${contentClassName}`}>
          {children}
        </div>
      )
  } else {
    return (
      <div className={`${classes.pageLayoutContent} ${hasPageControlBar ? classes.marginBelowControlBar : ''} ${contentClassName}`}>
        {children}
      </div>
    )
  }
}
